export default "__VITE_ASSET__CSuSp6Tq__"